<template>
  <main class="customer_join main" id="main_con">
    <div class="join_inner">
      <div class="text_area">
        <h2>받으신 인증 번호를<br />입력해 주세요.</h2>
        <p>{{ auth_txt }}</p>
      </div>
      <div class="input_txt">
        <div class="input">
          <input
            id="authNum"
            placeholder=""
            type="number"
            inputmode="numeric"
            pattern="[0-9]*"
            maxlength="6"
            v-model.trim="authNumber"
            @keyup="isAuthNumber"
          />
          <p class="input_time" :class="{ on: isStartCountdown }">
            {{ auth_number_placeholder }}
          </p>
        </div>
        <p class="input_valid" :class="{ on: isError }">
          {{ errormsg }}
        </p>
      </div>
      <div class="btn_num_send">
        <button @click="goJoinMobileAuth">인증번호 재발송</button>
      </div>
    </div>
    <countdown
      ref="countdown"
      :time="countdowntime"
      :auto-start="false"
      @progress="handleCountdownProgress"
      @start="handleCountdownStart"
      @abort="handleCountdownAbort"
      @end="handleCountdownEnd"
    >
    </countdown>
    <div class="join_btn_area">
      <div class="btn_txt">
        <p class="text_term">
          ‘인증 번호 확인’ 버튼을 누름으로써
          <span @click="goTerms('agreement', '약관정보')">이용약관</span>,
          <span @click="goTerms('personal', '개인정보취급방침')"
            >개인정보취급방침</span
          ><br />
          및
          <span @click="goTerms('geolocation', '위치기반서비스 이용약관')"
            >위치기반서비스 이용약관</span
          >에 동의하는 것으로 간주합니다.
        </p>
      </div>
      <button @click="handleAuthConfirm()">
        인증번호 확인
      </button>
    </div>
  </main>
</template>
<script>
import * as util from '@common/lib/common/utils.js';

import { authMapActions, authTypes } from '@common/store/modules';

import { mapActions as userMapActions } from '@common/store/modules/user';
import * as userTypes from '@common/store/modules/user/types';

import {
  mapActions as mobileMapActions,
  mapGetters as mobileMapGetters,
} from '@common/store/modules/mobile';
import * as mobileTypes from '@common/store/modules/mobile/types';

export default {
  name: 'joinMobileAuth',
  components: {},
  data() {
    return {
      errormsg: null,
      isError: false,
      authNumber: '',
      isConfirm: false,
      countdowntime: 1000 * 60 * 3,
      isStartCountdown: false,
      auth_number_placeholder: '',
      mobileNumber: '',
      auth_txt: '문자로 인증번호를 발송하였습니다.',
      dl_id: '',
      isExDeal: false,
      dealId: 0,
      redir: '',
      isRedir: false,
    };
  },
  created() {
    // 휴대폰 번호 입력하고 인증번호 발송했는지 확인, 새로고침하면 뒤로 가기 처리
    this.authSendCheck();

    this.dl_id = localStorage.getItem('dl_id');

    if (this.dl_id && !util.isApp()) {
      this.isExDeal = true;
      let dl_id_sp = this.dl_id.split('_');
      this.dealId = dl_id_sp[1];
    } else {
      this.isExDeal = false;
    }

    this.redir = localStorage.getItem('redir');

    if (this.redir && !util.isApp()) {
      this.isRedir = true;
    } else {
      this.isRedir = false;
    }
  },
  async mounted() {
    // this.$refs.countdown.abort();
    var authNum = document.querySelector('#authNum');
    authNum.focus();
    const target = document.querySelector('#main_con');
    setTimeout(() => {
      target.scrollTo(0, 0);
    }, 10);
    this.countdownStart();
  },
  computed: {},
  methods: {
    ...mobileMapActions([mobileTypes.MOBILE_DEAL_CHAT]),
    ...authMapActions([
      authTypes.AUTH_REQ,
      authTypes.AUTH_CONFIRM,
      authTypes.LOGIN,
      authTypes.SOCIAL_REGISTER,
    ]),
    ...userMapActions([userTypes.FIND_USER_BY_MOBILE_NUMBER]),
    goJoinMobileGender() {
      localStorage.setItem('join_authNumber', this.authNumber);

      this.$router.push({
        name: 'Auth.JoinGender',
      });
    },
    async handleAuthConfirm() {
      if (this.isError) {
        return false;
      }

      if (!this.isAuthNumber()) {
        return false;
      }

      const params = {
        authNumber: this.authNumber,
        inputValue: this.mobileNumber,
        authType: 'SMS',
      };
      // 인증번호 확인
      this[authTypes.AUTH_CONFIRM](params)
        .then(() => {
          this.isConfirm = true;
          this.$refs.countdown.abort();

          // 인증성공
          // 가입방법 ( mobile, kakao, apple )
          const joinMethod = localStorage.getItem('join_method');

          // 가입방법이 mobile
          if (joinMethod == 'mobile') {
            // 이미 가입한 사람인지 확인
            this[userTypes.FIND_USER_BY_MOBILE_NUMBER](this.mobileNumber)
              .then(() => {
                // 로그인
                this.login(this.mobileNumber, this.authNumber);
              })
              .catch(e => {
                // 다음 페이지
                this.goJoinMobileGender();
              });
          } else if (joinMethod == 'apple') {
            const join_appleId = localStorage.getItem('join_appleId');

            // 이미 가입한 사람인지 확인
            this[userTypes.FIND_USER_BY_MOBILE_NUMBER](this.mobileNumber)
              .then(() => {
                // 소셜 등록
                const params = {
                  providerId: 'APPLE',
                  providerUserId: join_appleId,
                  email: '',
                  gender: '',
                  ageRange: '',
                  mobileNumber: this.mobileNumber,
                  nickname: '',
                  areaId: '',
                  codeType: '',
                  joinRoute: '',
                };

                if (util.isApp()) {
                  params.joinRoute = 'APP';
                } else {
                  if (util.checkMobile()) {
                    params.joinRoute = 'MOBILE';
                  } else {
                    params.joinRoute = 'PC';
                  }
                }

                // 1. 소셜 등록
                this[authTypes.SOCIAL_REGISTER](params).then(res => {
                  const passwordkey = '_APPLE';
                  const username = this.mobileNumber;
                  const password = `${join_appleId}${this.mobileNumber}${passwordkey}`;

                  this.login(username, password, 12);
                });
              })
              .catch(e => {
                // 다음 페이지
                this.goJoinMobileGender();
              });
          } else {
            // 다음 페이지
            this.goJoinMobileGender();
          }
        })
        .catch(msg => {
          this.isConfirm = false;
          this.errormsg = '인증번호가 일치하지 않습니다.';
          this.isError = true;

          console.log(2);
        });
    },
    async login(username, password, roles = 10) {
      let loginParam = {
        username: username,
        password: password,
        roles: roles,
      };
      console.log('loginParam :: {}', loginParam);

      await this[authTypes.LOGIN](loginParam).then(() => {
        if (this.isExDeal) {
          // 채팅방으로 이동 처리
          this.enterChatRoom(this.dealId);
        } else {
          if (this.isRedir) {
            this.$router.push({ path: this.redir }).catch(err => {
              this.$router.push({ name: 'Home' });
            });
          } else {
            this.$router.push({ name: 'Home' });
          }
        }
      });
    },
    isAuthNumber() {
      this.authNumber = util.numberFormatter(this.authNumber);
      console.log(this.authNumber);
      if (this.authNumber.length == 6) {
        this.errormsg = '';
        this.isError = false;
        return true;
      } else {
        this.errormsg = '인증번호가 일치하지 않습니다.';
        this.isError = true;
        return false;
      }
    },
    handleCountdownProgress(data) {
      let { minutes, seconds } = data;
      seconds = seconds < 10 ? `0${seconds}` : seconds;
      this.auth_number_placeholder = `${minutes}:${seconds}`;
    },
    handleCountdownStart() {
      this.isStartCountdown = true;
    },
    handleCountdownEnd() {
      this.isConfirm = false;
      this.isStartCountdown = false;
      this.auth_number_placeholder = '0:00';
      this.isError = true;
      this.errormsg = '인증번호가 만료되었습니다';
    },
    handleCountdownAbort() {
      this.isStartCountdown = false;
    },
    authSendCheck() {
      this.mobileNumber = localStorage.getItem('join_mobile');
      if (this.$route.params.authSend != 'success' || !this.mobileNumber) {
        this.$router.go(-1);
        return;
      }
    },
    countdownStart() {
      this.$refs.countdown.end();
      this.isConfirm = false;
      this.isError = false;
      this.errormsg = null;
      this.$refs.countdown.totalMilliseconds = this.countdowntime;
      this.$refs.countdown.start();
      this.authNumber = '';
      // this.errormsg = '인증번호가 발송 되었습니다.';
      // this.authButtonLabel = '재발송';
      // this.isContentsView = true;
    },
    goJoinMobileAuth() {
      const params = {
        inputValue: this.mobileNumber,
        authType: 'SMS',
      };

      // 인증번호 발송
      this[authTypes.AUTH_REQ](params)
        .then(msg => {
          if (this.mobileNumber === '01012341234') {
            alert(msg.message);
          }

          this.countdownStart();
          this.auth_txt = '문자로 인증번호를 재발송하였습니다.';

          var authNum = document.querySelector('#authNum');
          authNum.focus();
        })
        .catch(err => {
          this.isConfirm = false;
          this.isStartCountdown = false;
          this.auth_number_placeholder = '0:00';
          this.isError = true;
          this.errormsg = '인증번호 발송이 실패하였습니다.';
        });
    },
    goTerms(type, title) {
      this.$router.push({
        name: 'Agreement.Terms',
        params: { type: type, title: title },
      });
    },
    enterChatRoom(id) {
      const params = {
        id: id,
      };

      this[mobileTypes.MOBILE_DEAL_CHAT](params)
        .then(res => {
          console.log('resresresresresresres');
          console.log(res);

          this.$router.push({
            name: 'chat.room',
            params: {
              uuid: res,
            },
          });
        })
        .catch(e => {
          console.log('error');
        });
    },
  },
};
</script>
